// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePencilLine as RawLucidePencilLine } from "lucide-react";
export const LucidePencilLine = /* @__PURE__ */ createIcon(RawLucidePencilLine, "LucidePencilLine", 2);
